export const LIST_WIDTH = {
  s: 100,
  sm: 150,
  md: 200,
  lg: 250,
  xl: 300,
  xxl: 350,
  TASK_NAME: 600,
  ELAPSED_NUMBER: 125,
  HUMAN_READABLE_ID: 175,
  HUMAN_NAME: 150,
  OBJECT_NAME: 150,
  PHONE_NUMBER: 150,
  TIME_DATE: 200,
  STATUS: 200,
  default: 150,
};

export const ARCHIVED_COLUMN = {
  headerName: 'Archived',
  field: 'archived',
  width: 200,
  cellRenderer: 'statusComponent',
};
